module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-pt.f0f31f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/grac-oidd-competition-pt.jpg
// module id = Lysv
// module chunks = 0